import { getEmailServerHeaders } from './emailServerClient';

import { MemberRole } from '../../types/organisation';

export const sendOrganisationInvite = async (
  email: string,
  orgName: string,
  role: MemberRole,
  inviteLink: string
): Promise<void> => {
  // Get role display name
  const getRoleDisplay = (role: MemberRole) => {
    switch (role) {
      case 'moderator':
        return 'Teacher/Moderator';
      case 'member':
        return 'Student/Member';
      case 'organisationAdmin':
        return 'Administrator';
      default:
        return role;
    }
  };

  const response = await fetch('https://email-server-dot-overhear-2.uc.r.appspot.com/api/send-email', {
    method: 'POST',
    headers: getEmailServerHeaders(),
    body: JSON.stringify({
      to: email,
      subject: `Invitation to join ${orgName}`,
      text: `
Hello,

You have been invited to join ${orgName} as a ${getRoleDisplay(role)}.

To accept this invitation, please click on the following link:
${inviteLink}

This invitation link will expire in 7 days.

If you have any questions, please contact the organisation administrator.

Best regards,
The Overhear Team
      `.trim()
    }),
  });

  if (!response.ok) {
    console.error('Failed to send invitation email');
    throw new Error('Failed to send invitation email');
  }
};

/**
 * Sends availability request email to facilitators for a workshop.
 * 
 * @param {string} facilitatorEmail - The email address of the facilitator.
 * @param {string} facilitatorName - The name of the facilitator.
 * @param {Object} workshopDetails - Workshop details object.
 * @param {string} responseLink - Link for facilitator to respond with their availability.
 * @returns {Promise<void>} A promise that resolves when the email is sent successfully.
 * @throws {Error} Throws an error if the email sending fails.
 */
